import { jsx as _jsx } from "react/jsx-runtime";
export const InfoM = ({ color = 'currentColor', ...props })=>/*#__PURE__*/ _jsx("svg", {
        fill: "none",
        height: "64",
        viewBox: "0 0 64 64",
        width: "64",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ _jsx("path", {
            d: "M32 5.75003C46.4975 5.75003 58.25 17.5026 58.25 32C58.25 46.4975 46.4975 58.25 32 58.25C17.5025 58.25 5.75 46.4975 5.75 32C5.75 17.5026 17.5025 5.75003 32 5.75003ZM32 8.25003C18.8832 8.25003 8.25 18.8833 8.25 32C8.25 45.1168 18.8832 55.75 32 55.75C45.1168 55.75 55.75 45.1168 55.75 32C55.75 18.8833 45.1168 8.25003 32 8.25003ZM34.25 28V43.75H38C38.6904 43.75 39.25 44.3097 39.25 45C39.25 45.6904 38.6904 46.25 38 46.25H27C26.3096 46.25 25.75 45.6904 25.75 45C25.75 44.3097 26.3096 43.75 27 43.75H31.75V29.25H27C26.3096 29.25 25.75 28.6904 25.75 28C25.75 27.3097 26.3096 26.75 27 26.75H33C33.6758 26.75 34.25 27.2917 34.25 28ZM32 15.75C32.6904 15.75 33.25 16.3097 33.25 17V19.667C33.2498 20.3572 32.6902 20.917 32 20.917C31.3098 20.917 30.7502 20.3572 30.75 19.667V17C30.75 16.3097 31.3096 15.75 32 15.75Z",
            fill: color
        })
    });

//# sourceMappingURL=info-m.js.map